var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditPrimaryColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 14.3751V17.5001H5.0625L13.3575 8.28346L10.545 5.15846L2.25 14.3751ZM15.5325 5.8668C15.825 5.5418 15.825 5.0168 15.5325 4.6918L13.7775 2.7418C13.485 2.4168 13.0125 2.4168 12.72 2.7418L11.3475 4.2668L14.16 7.3918L15.5325 5.8668Z",
    fill: "#13214E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPrimaryColor);
export default __webpack_public_path__ + "static/media/edit-primary-color.f5bd511813eaf45095cdeeca6b4b0921.svg";
export { ForwardRef as ReactComponent };